import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
 
  constructor(private http: HttpClient) { }

  getTranslation(language: string): Observable<any> {
    const url = `/assets/i18n/${language}.json`;
    return this.http.get(url);
  }
}
